import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

/**
 * Bottom-sheet confirmation mirroring the recruitee-mobile ConfirmationModal's
 * simple form: a title, an explanatory message and a single primary action.
 * Present via the host's sheet presenter with `background: 'default'`.
 */
@Component({
  selector: 'tlm-confirmation-sheet',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './confirmation-sheet.component.html',
  styleUrl: './confirmation-sheet.component.less',
})
export class TellentMobileConfirmationSheetComponent {
  public readonly title = input.required<string>();
  public readonly message = input('');
  public readonly confirmLabel = input.required<string>();
  // Callback alternative to the `confirmed` output for hosts that present this
  // component through an overlay controller, where output bindings are unavailable.
  public readonly confirmHandler = input<() => void>();

  public readonly confirmed = output<void>();

  protected confirm(): void {
    this.confirmed.emit();
    this.confirmHandler()?.();
  }
}
